import React, { useEffect, useState } from 'react';
import { useModal } from '@src/state/modal';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { useProvider } from '@src/state/provider';
import { useGetOONConsentQuery } from '@sde/widgets-core/src/common/hooks/useGetOONConsentModalQuery';
import { event } from '@uhg-abyss/web/tools/event';
import { OONConsentModal } from './OONConsentModal';
import { OONConsentOptOutConfirmationModal } from './OONConsentOptOutConfirmationModal';

export const OONConsent = () => {
  const { user } = useUser.state();
  const [providerEmail, setProviderEmail] = useState('');
  const { provider } = useProvider.state();
  const { corporateProviderMpin, taxIdNumber, userId } = provider;
  const { toggleModal } = useModal.actions();

  const [, getPopup] = useGetOONConsentQuery({
    onCompleted: (response) => {
      if (response.responseFlag) {
        toggleModal({
          key: 'oon-consent-modal',
          isOpen: true,
        });
        event('OON_CONSENT_MODAL_OPEN', {
          modalName: 'Paperless Consent Modal',
        });
      } else {
        toggleModal({
          key: 'oon-consent-modal',
          isOpen: false,
        });
      }
      setProviderEmail(response.providerEmailId);
    },
  });

  const handleOONConsent = () => {
    if (corporateProviderMpin && userId) {
      const result = (user.providerOrg || []).find((item) => {
        return (
          item.corpMpin === corporateProviderMpin &&
          item.id === userId &&
          item.paa === true
        );
      });
      if (result) {
        getPopup({
          variables: {
            corpOwnerId: corporateProviderMpin,
            taxIdNumber,
          },
        });
      }
    }
  };

  useEffect(() => {
    handleOONConsent();
  }, [corporateProviderMpin, taxIdNumber, userId]);

  return (
    <React.Fragment>
      <OONConsentModal
        providerEmail={providerEmail}
        corporateProviderMpin={corporateProviderMpin}
        taxIdNumber={taxIdNumber}
      />
      <OONConsentOptOutConfirmationModal
        corporateProviderMpin={corporateProviderMpin}
        taxIdNumber={taxIdNumber}
      />
    </React.Fragment>
  );
};
